<script type="text/javascript">
	import { get } from "svelte/store";
	import MapDataSource from "../Map/Enums/MapDataSource";
	import MapLayerManager from "../Map/MapLayerManager";
	import MapStore from "../Map/Store";
	import Timezones from "./Timezones.js";
	
	let timezonesInitialised = Timezones.meta.initialised;
	let timezoneVisible = MapStore.timezoneVisible;
	let lastUpdated = Timezones.meta.lastUpdated;
	$: {
		if ($timezoneVisible) {
			Timezones.initMap();
		}
		else {
			Timezones.deinitMap();
		}
		if ($timezoneVisible && !$timezonesInitialised) {
			Timezones.load();
		}
	}

	$: {
		$lastUpdated;
		if ($timezonesInitialised) {
			const timezoneLayerGeojson = Timezones.get("TimezoneLayer");
			const timezoneLabelsGeojson = Timezones.get("TimezoneLabels");

			const map = get(MapStore.mapbox.instance);
			map.getSource(MapDataSource.TIMEZONE).setData(timezoneLayerGeojson);
			map.getSource(MapDataSource.TIMEZONE_LABELS).setData(timezoneLabelsGeojson);

			MapLayerManager.updateVisibleLayers();
		}
	};

</script>
